import React, { useState } from "react";
import "../styles/Login.css";
import logo from "../images/amazon-logo.svg";
import { Link, useHistory } from "react-router-dom";
import { auth } from "../firebase";

function Login() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const signIn = (e) => {
    e.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .then((auth) => {
        if (auth) {
          history.push("./");
        }
      })
      .catch((error) => setErrorMessage(error.message));
  };

  const register = (e) => {
    e.preventDefault();
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        //if the authentiction is done successfully then go to home page
        if (auth) {
          history.push("./");
        }
      })
      .catch((error) => setErrorMessage(error.message));
  };

  return (
    <div className="login__body">
      <div className="login">
        <Link to="./">
          <img src={logo} alt="" className="Login__amazonlogo" />
        </Link>
        <div className="login__container">
          <h1>sign-in</h1>
          <form className="login__form">
            <h5>E-mail</h5>
            <input
              type="text"
              value={email}
              className="login__email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <h5>Password</h5>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 6 character"
            />
            <button className="login__signInButton" onClick={signIn}>
              Sign In
            </button>
          </form>
          <p>
            By continuing, you agree to Amazon's <strong>Ahmed sherif</strong>{" "}
            Clone Conditions of Use and Privacy Notice
          </p>

          <button className="login__register" onClick={register}>
            Create Amazon Account
          </button>
          <p className="login__errorMessage">
            {errorMessage && <span>!</span>} {errorMessage}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
